<div v-if="getContent" class="matrix_tooltipContainer">
    <appAwesomeIcon icon="question-circle" useClass="fa fa-question-circle"  v-if="getContent && !getIsMobile" v-tooltip.bottom-top="getTriggerEvent(getContent)"></appAwesomeIcon>
    <appAwesomeIcon icon="question-circle" useClass="fa fa-question-circle"  v-if="getContent && getIsMobile" v-tooltip.left="getTriggerEvent(getContent)" ></appAwesomeIcon>  
  </div>
  